import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserInfo } from "../../redux/user/user.selectors";
import MenuItemSingle from "../../components/menuItemSingle/menuItemSingle.component";


const MenuItems = ({ location, selectUserInfo }) => {
  console.log("location", location.pathname);
  const { new_messages } = selectUserInfo;
  // const handle_active = () => {
  //   location.pathname === "/reqs" ? true : false;
  // };

  const { pathname } = location;
  const [unread, setUnread] = useState(true);

  return (
    <ul>
      <Link
        to={pathname === "/app2/reqs" ? "" : "/app2/reqs"}
        disabled={pathname === "/app2/reqs" ? true : false}
      >
        <MenuItemSingle
        // className="pulsant-effect"
          title="درخواست‌ها"
          active={pathname === "/app2/reqs" || pathname === "/app2/without" ? true : false}
        />
      </Link>
      <Link
        to={pathname === "/app2/wallet" ? "" : "/app2/wallet"}
        disabled={pathname === "/app2/wallet" ? true : false}
      >
        <MenuItemSingle
          title="کیف پول"
          active={pathname === "/app2/wallet" ? true : false}
        />
      </Link>
      <Link
        to={pathname === "/app2/messages" ? "" : "/app2/messages"}
        disabled={pathname === "/app2/messages" ? true : false}
      >
        <MenuItemSingle
          title="صندوق پیام"
          unread={new_messages === 0 ? false : true}
          active={pathname === "/app2/messages" ? true : false}
        />
      </Link>
      <Link
        to={pathname === "/app2/support" ? "" : "/app2/support"}
        disabled={pathname === "/app2/support" ? true : false}
      >
        <MenuItemSingle
          title="پشتیبانی"
          active={pathname === "/app2/support" ? true : false}
        />
      </Link>
    </ul>
  );
};

// export default withRouter(MenuItems);
const mapStateToProps = createStructuredSelector({
  selectUserInfo: selectUserInfo,
});

export default connect(mapStateToProps)(withRouter(MenuItems));
